import { render, staticRenderFns } from "./TableResumenBiasMail.vue?vue&type=template&id=52086f2f&scoped=true&"
import script from "./TableResumenBiasMail.vue?vue&type=script&lang=js&"
export * from "./TableResumenBiasMail.vue?vue&type=script&lang=js&"
import style0 from "./TableResumenBiasMail.vue?vue&type=style&index=0&id=52086f2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52086f2f",
  null
  
)

export default component.exports